import React, { useEffect, useState } from 'react';
import { setUrlCategoryType } from 'utils/appUtils';

import * as S from './styles';

const SectionItem = ({ hideArrow, id, name, type, active }) => {
    const [sectionType, setSectionType] = useState();

    useEffect(() => {
        setSectionType(setUrlCategoryType(type.toLowerCase()));
    }, []);

	return (
		<S.SectionItemWrapper to={`/secao/${sectionType}/${id}`} className={active && 'active'}>
            <S.SectionItemText>{name}</S.SectionItemText>
            <S.SectionItemArrow hideArrow={hideArrow} />
        </S.SectionItemWrapper>
	);
}

export default SectionItem;